import Framework7 from 'framework7/bundle';

const config = {};

config.app = {
    id: 'in.jodhana.pathak',
    version: '1.0.0',
    title: 'Pathak',
    title_hi: 'पथक',
    tagline: '',
    description: ''
}

config.navigation = {
    splash: {
        enabled: !Framework7.device.standalone && !Framework7.device.cordova,
        duration: 3000,
    },
    walkthrough: {
        enabled: false,
        showFirstTimeOnly: true
    },
    authentication: {
        required: true,
        guestAccess: false,
        ignoreRoutes: [
          '/',
          '/splash/',
          '/walkthrough/',
          '/login/',
          '/signup/',
          '/forgot-password/',
          '/verify-email/',
          '/verify-otp/',
          '/sidebar/',
          '/feedback/',
          '/contact/',
          '/team/'
        ]
    },
    home: {
        url: '/home/'
    }
}

config.theming = {
    enabled: true,
    theme: 'auto',
    color: '#1877F2',
    mode: 'system'
}


config.layout = {
    singleView: {
        sidebar: {
            enabled: true
        },
        tabbar: {
            enabled: true
        }
    },
    tabView: {
        sidebar: {
            enabled: true
        }
    },
    default: Framework7.device.cordova ? 'tabView' : 'singleView'
}


/*
|------------------------------------------------------------------------------
| Theming
|------------------------------------------------------------------------------
*/

config.theming = {
    enabled: true,
    theme: 'auto',
    color: '#1877F2',
    mode: 'system'
}


export default config;